export enum AttachmentGroup {
  DEATH_CERTIFICATE = '1',
  OTHERS = '2',
  FUNERAL_HOME_BILLS = '3',
  RIB = '4',
  FUNERAL_HOME_PAYMENT_AUTHORIZATION = '5',
}
